<template>
   	<div class="bg">
   		<div class="songNum">共有 {{searchTotal}} 条搜索结果</div>
   		<v-songlist></v-songlist>
   	</div>
</template>

<script>
import songList from '../components/songList.vue'
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
      
      }
    },
    computed: {
    	...mapGetters(['searchTotal'])
    },
    components:{
	  'v-songlist':songList,
  	},
    methods: {
      
    }
  }
</script>

<style scoped>
.bg{width: 100%;height: 100%;overflow: hidden;background: url(../assets/images/bg01.jpg);background-size:15%; }
.songList{width: 100%;position: absolute;top:154px;color: #fff;z-index: 8;}
.songNum{position: absolute;top:120px;width: 100%;height: 34px;background: #000;color: #ccc;padding-left: 28px;line-height: 34px;font-size: 14px;box-sizing: border-box;}
</style>


// WEBPACK FOOTER //
// search.vue?36db565c